export default __webpack_public_path__ + "static/media/video10.cd7b2f94.mp4";